import 'C:\\Projects\\genkei\\zumeco\\static\\shared\\components\\Dialog.tsx.esbuild-plugin-windicss.css';
import { cx } from '@linaria/core';
import { mdiClose } from '@mdi/js';
import type { JSX, RefObject } from 'preact';
import { forwardRef, memo } from 'preact/compat';
import { useMobileSafariVirtualKeyboardShown } from '../../doodle/view/CanvasContainer';
import { i18n } from '../i18n';
import { Icon } from './Icon';
import { ToolbarButton } from './ToolbarButton';
export const showModal = ({
  current
}: RefObject<HTMLDialogElement | null>) => {
  if (current) {
    current.showModal();
    current.scrollTo(0, 0);
  }
};
const close: preact.MouseEventHandler<HTMLButtonElement> = event => event.currentTarget.closest('dialog')?.close();
type OnClose = preact.DOMAttributes<HTMLDialogElement>['onClose'];
type OnCancel = preact.DOMAttributes<HTMLDialogElement>['onCancel'];
export const Dialog = memo(forwardRef<HTMLDialogElement, {
  className?: string;
  caption: string;
  header?: JSX.Element;
  onClose?: OnClose;
  onCancel?: OnCancel;
  children: any;
}>(({
  className,
  caption,
  header,
  onClose,
  onCancel,
  children
}, ref) => {
  const isMobileSafariKeyboardShown = useMobileSafariVirtualKeyboardShown();
  return <dialog ref={ref} class={cx('w-600px !p-8 !pt-6 rounded-lg', isMobileSafariKeyboardShown && '!-mt-24', className)} onClose={onClose} onCancel={onCancel}>
        <div class="flex items-center mb-5">
          <h3 data-text={caption} class="flex-auto">
            {caption}
          </h3>
          {header}
          <ToolbarButton className="-my-1 -mr-1 ml-3" title={i18n.close} onClick={close}>
            <Icon icon={mdiClose} />
          </ToolbarButton>
        </div>
        {children}
      </dialog>;
}));